export default "__VITE_ASSET__CRG8tnVT__"